import React from "react";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

const BreachArchiveConfirmation = ({ closeDialog, handleConfirm }: any) => {
    return (
        <div>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="briefcase" />
                </div>
                <h3 className="content-sub-title">Archive Alert Confirmation</h3>
            </div>
            <div className="dialog-body">
                <p>
                    Please confirm that you'd like to archive this alert. We'll be here if you're ever concerned about this alert in future. Open your case and
                    connect with your Resolution Specialist at any time.
                </p>
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button onClick={closeDialog} type="button" className="btn-default btn-link">
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className={`btn-default btn-primary`}
                            onClick={() => {
                                handleConfirm();
                                window.addToDataLayer({ event: "breachIQBtnArchiveConfirm" });
                            }}
                        >
                            <span className="btn-text">Archive Alert</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BreachArchiveConfirmation;
